import {Injectable, Injector} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {catchError, tap} from 'rxjs/operators';

import {AuthService} from '../service/auth.service';
import {BehaviorSubject, Observable} from 'rxjs';
import 'rxjs/add/operator/take';
import {LoaderService} from 'src/service/loader-service';
import {NotificationService} from "../../shared/service/notification.service";
import {NotificationType} from "../../shared/constants/notification-type.enum";
import {CommonConstants} from "../../shared/constants/common-constants.enum";

@Injectable()
export class AddHttpHeaderInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private authService: AuthService,
    private loaderService: LoaderService,
    private notification: NotificationService) {
  }

  private tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Get the access token, token type from the service.
    request = this.addAuthenticationToken(request);
    // @key: ignoreContentType prevent set (headers) content type
    if (!request.headers.has('Content-Type') && !request.headers.has('ignoreContentType')) {
      request = request.clone({headers: request.headers.set('Content-Type', 'application/json')});
    }
    // Add no-cahe for IE 10
    if (request.method === 'GET') {
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache'
        }
      });
    }
    this.toggleLoading(request);
    return next
      .handle(request)
      .pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            this.toggleLoading(request, false);
          }
        }), catchError((error: HttpErrorResponse) => {
          if (error instanceof HttpErrorResponse) {
            switch ((error as HttpErrorResponse).status) {
              case 401:
                return this.handle401Error(request, next);
              case 403:
                return this.handle403Error(request);
              default:
                this.toggleLoading(request, false);
                if (error.error instanceof Blob && error.error.type === "application/json") {
                  const reader = new FileReader();
                  reader.onload = (e) => {
                    const errorObject = JSON.parse(reader.result as string);
                    this.notification.open({
                      type: NotificationType.ERROR,
                      title: 'Đã xảy ra lỗi',
                      body: errorObject.errors[0].message
                    });
                  };
                  reader.readAsText(error.error);
                } else {
                  this.notification.open({
                    type: NotificationType.ERROR,
                    title: 'Đã xảy ra lỗi',
                    body: error.error.errors[0].message
                  });
                }
                // tslint:disable-next-line: deprecation
                return Observable.throw(error);
            }
          } else {
            // tslint:disable-next-line: deprecation
            return Observable.throw(error);
          }
        })
      );
  }

  addAuthenticationToken(request, token = null): HttpRequest<any> {
    // Get access token from Local Storage
    const accessToken = token ? token : this.authService.getAccessToken();

    // If access token is null this means that user is not logged in
    // And we return the original request
    if (!accessToken) {
      return request;
    }

    // We clone the request, because the original request is immutable
    return request.clone({
      setHeaders: {
        'Omni-Token': `Bearer ${accessToken}`
      }
    });
  }

  private toggleLoading(request: HttpRequest<any>, show = true) {
    /*if (!request.url.includes('login')) {
      return;
    }*/

    if (request.url.includes('/check') || request.url.includes('/unique-') || request.url.includes('/api/station/list')) {
      return;
    }
    if (show) {
      this.loaderService.show();
    } else {
      setTimeout(() => {
        this.loaderService.hide();
      }, 250);
    }
  }

  handle403Error(req: HttpRequest<any>) {
    setTimeout(() => {
      this.notification.open({
        type: NotificationType.ERROR,
        body: CommonConstants.SESSION_EXPIRED_ERROR,
        title: CommonConstants.SESSION_EXPIRED_TITLE
      });
    }, 250);
    this.authService.logout();
    this.toggleLoading(req, false);
    return Observable.throw('');
  }

  handle401Error(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes('login')) {
      // We do another check to see if refresh token failed
      // In this case we want to logout user and to redirect it to login page

      // if (req.url.includes('refresh')) {
      //   this.authService.logout();
      // }
      this.notification.open({
        title: CommonConstants.LOGIN_FAILED_HEADER,
        type: NotificationType.ERROR,
        body: CommonConstants.LOGIN_FAILED_CONTENT
      });
      this.toggleLoading(req, false);
      // tslint:disable-next-line: deprecation
      return Observable.throw('');
    }
    // if (!this.isRefreshingToken) {
    //   this.isRefreshingToken = true;

    //   // Reset here so that the following requests wait until the token
    //   // comes back from the refreshToken call.
    //   this.tokenSubject.next(null);

    //   return this.authService.refreshAccessToken()
    //     .switchMap((newToken: string) => {
    //       if (newToken) {
    //         this.tokenSubject.next(newToken);
    //         return next.handle(this.addAuthenticationToken(req, newToken));
    //       }

    //       // If we don't get a new token, we are in trouble so logout.
    //       return this.authService.logout();
    //     })
    //     .catch(error => {
    //       // If there is an exception calling 'refreshToken', bad news so logout.
    //       return this.authService.logout();
    //     })
    //     .finally(() => {
    //       this.isRefreshingToken = false;
    //       this.toggleLoading(req, false);
    //     });
    // } else {
    return this.tokenSubject
      .filter(token => token != null)
      .take(1)
      .switchMap(token => {
        return next.handle(this.addAuthenticationToken(req, token));
      });
    // }
  }
}
